import { BlogPost } from './types';

export const subjectGuidePosts: BlogPost[] = [
  {
    id: '4',
    slug: 'physics-problem-solving-techniques',
    title: 'Advanced Physics Problem-Solving Techniques for JEE',
    excerpt: 'Unlock the secrets to solving complex physics problems with proven strategies used by top JEE rankers.',
    content: `
      <p>Physics can be daunting, but with the right approach, even the most complex problems become manageable. Here's how top JEE rankers tackle physics challenges.</p>

      <h2>The Systematic Approach</h2>
      <h3>Step 1: Read and Visualize</h3>
      <p>Read the problem carefully. Draw diagrams. Visualize the physical scenario. Half the battle is won with proper understanding.</p>

      <h3>Step 2: Identify Concepts</h3>
      <p>What physics principles are involved? Conservation laws? Kinematics? Electromagnetism? List them all.</p>

      <h3>Step 3: Write Known and Unknown</h3>
      <p>Systematically list all given information and what you need to find. This prevents errors and organizes your thinking.</p>

      <h3>Step 4: Choose Your Approach</h3>
      <p>Select the most efficient method. Sometimes energy considerations are simpler than force analysis.</p>

      <h2>Essential Problem-Solving Tools</h2>
      
      <h3>Dimensional Analysis</h3>
      <p>Use dimensions to check if your answer makes sense and to eliminate wrong options in MCQs quickly.</p>

      <h3>Limiting Cases</h3>
      <p>Check extreme cases. If friction becomes zero, does your answer match the frictionless scenario?</p>

      <h3>Symmetry Arguments</h3>
      <p>Use symmetry to simplify problems. It's often a powerful shortcut.</p>

      <h2>Common Mistakes to Avoid</h2>
      <ul>
        <li>Forgetting to convert units</li>
        <li>Incorrect sign conventions</li>
        <li>Ignoring limiting conditions</li>
        <li>Mathematical errors in algebra</li>
      </ul>

      <h2>Practice Strategy</h2>
      <p>Start with simple problems. Master the basics before attempting complex ones. Practice at least 10-15 problems per topic.</p>

      <h2>Advanced Tips</h2>
      <ul>
        <li>Develop intuition through repeated practice</li>
        <li>Learn multiple methods for solving the same problem</li>
        <li>Focus on conceptual clarity, not rote formulas</li>
        <li>Review and understand solutions even when you get the answer right</li>
      </ul>
    `,
    author: {
      name: 'Prof. Arun Kumar',
      role: 'Physics Faculty, IIT-JEE Expert'
    },
    category: 'Subject Guide',
    tags: ['Physics', 'JEE', 'Problem Solving', 'Study Techniques'],
    featuredImage: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800&h=400&fit=crop',
    publishedDate: '2024-12-28',
    readTime: '9 min read',
    views: 1650
  },
  {
    id: '5',
    slug: 'neet-biology-preparation-guide',
    title: 'Complete NEET Biology Preparation Guide 2025',
    excerpt: 'A comprehensive roadmap to master Biology for NEET with focus on high-weightage topics and memory techniques.',
    content: `
      <p>Biology contributes 50% of NEET questions, making it the most important subject. Here's your complete guide to ace it.</p>

      <h2>Understanding NEET Biology</h2>
      <p>NEET Biology tests both conceptual understanding and memory. You need to balance both aspects effectively.</p>

      <h2>High-Weightage Topics</h2>
      
      <h3>From Class 11</h3>
      <ul>
        <li>Biological Classification</li>
        <li>Cell Structure and Function</li>
        <li>Plant Physiology</li>
        <li>Human Physiology</li>
      </ul>

      <h3>From Class 12</h3>
      <ul>
        <li>Reproduction in Organisms</li>
        <li>Genetics and Evolution</li>
        <li>Biology and Human Welfare</li>
        <li>Ecology and Environment</li>
      </ul>

      <h2>Memory Techniques</h2>
      
      <h3>Mnemonics</h3>
      <p>Create memorable phrases for complex lists. For taxonomy: "King Philip Came Over For Good Soup" (Kingdom, Phylum, Class, Order, Family, Genus, Species).</p>

      <h3>Mind Maps</h3>
      <p>Visual representations help connect related concepts. Create mind maps for each chapter.</p>

      <h3>Flashcards</h3>
      <p>Use flashcards for quick revision of terms, definitions, and diagrams. Review them daily.</p>

      <h2>NCERT is King</h2>
      <p>Cannot be stressed enough—NCERT textbooks are your bible. Read them at least 3-4 times. Most questions come directly from NCERT.</p>

      <h2>Diagram Practice</h2>
      <p>Practice drawing all NCERT diagrams. Many questions involve diagram-based problems.</p>

      <h2>Previous Year Analysis</h2>
      <p>Solve past 10 years of NEET papers. This reveals patterns and frequently asked concepts.</p>

      <h2>Monthly Revision Cycle</h2>
      <ul>
        <li>Week 1-2: New topics</li>
        <li>Week 3: Revision of previous month's topics</li>
        <li>Week 4: Test and analysis</li>
      </ul>

      <h2>Common Mistakes</h2>
      <ul>
        <li>Ignoring NCERT for reference books</li>
        <li>Not revising regularly</li>
        <li>Focusing only on theory, ignoring diagrams</li>
        <li>Memorizing without understanding</li>
      </ul>
    `,
    author: {
      name: 'Dr. Sneha Patel',
      role: 'MBBS, NEET Biology Expert'
    },
    category: 'Subject Guide',
    tags: ['Biology', 'NEET', 'Study Guide', 'Exam Preparation'],
    featuredImage: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=800&h=400&fit=crop',
    publishedDate: '2024-12-20',
    readTime: '10 min read',
    views: 2300
  }
];
